module.exports = __webpack_public_path__ + "site/img/Maps_3ShauKeiWan.f326e4c7.jpg";